import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface PlaceOrderMutationObject {
  mutation: {
    placeOrder: {
      __args: {
        input: {
          cart_id: string
        }
      }
      order: {
        order_id: boolean
      }
    }
  }
}

export const placeOrderMutationObject: PlaceOrderMutationObject = {
  mutation: {
    placeOrder: {
      __args: {
        input: {
          cart_id: ''
        }
      },
      order: {
        order_id: true
      }
    }
  }
}

interface PlaceOrderMutationInput {
  cartId: string
}

export type PlaceOrderMutation = (input: PlaceOrderMutationInput) => Promise<FetchResult<any>>

export const createPlaceOrderMutation = ({ getMutations }: ServiceDependencies): PlaceOrderMutation => async ({ cartId }) => {
  const mutation = getMutations().placeOrderMutation
  mutation.mutation.placeOrder.__args.input.cart_id = cartId

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
